// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1COq7","toggleWrap":"styles_toggleWrap__3ofTp","content":"styles_content__3pbg4","selectAreaCode":"styles_selectAreaCode__1i32x"};